import { Component, HostBinding, OnDestroy, ViewChild } from '@angular/core';
import { CustomFieldProfile } from '../../../../models/custom-fields';
import { DrRequestInfo } from '../../../../models/dr-request-info';
import { Endpoint, HelpIndex, SettingsType } from '../../../../models/enums';
import { GenericColDef, GridContext } from '../../../../models/grid-context';
import { ActionType, ObjectActionListType, Permissions } from '../../../../models/permission';
import { SettingsNavigationContentComponent } from '../../../../models/settings-navigation-content-component';
import { Template } from '../../../../models/template';
import { CommonService } from '../../../../services/common/common.service';
import { RestService } from '../../../../services/rest/rest.service';
import { GenericGridComponent } from '../../../generic-grid/generic-grid.component';
import { GenericTreeNode } from '../../../generic-tree/generic-tree-node';
import { CreateEditEntityModalComponent } from '../../create-edit-entity-modal/create-edit-entity-modal.component';
import { MetadataService } from '../../../../services/metadata/metadata.service';

@Component({
    standalone: false,
    selector: 'res-custom-fields',
    templateUrl: './custom-fields.component.html'
})
export class CustomFieldsComponent implements SettingsNavigationContentComponent, OnDestroy {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild(GenericGridComponent, { static: true }) genericGrid: GenericGridComponent;

    isDirty: boolean;
    hasPermissions = true;
    validChanges = true;

    gridName = 'Custom Fields';
    automationId = 'custom-fields';
    helpIndex: HelpIndex;
    settingsType?: SettingsType;
    projectHandle?: string;

    isBusy = false;
    isBusyMessage = 'Loading Custom Fields ...';
    currentHandle = '';
    profile: CustomFieldProfile;

    constructor(private commonService: CommonService, private restService: RestService, private metadataService: MetadataService) { }

    columnDefs = new Array<GenericColDef>(
        {
            headerName: 'Name',
            field: 'name',
            sortBy: 'name',
            automationId: this.automationId,
            lockVisible: true
        },
        {
            headerName: 'Description',
            field: 'description',
            automationId: this.automationId
        }
    );

    rowDisableRules = {
        'disabled-row': () => {
            return !this.hasPermissions;
        }
    };
    requestInfo = new DrRequestInfo({
        endpoint: Endpoint.projectManager_getCustomMetadataFieldsProfile,
        responseName: 'customMetadataFields',
        data: {}
    });
    gridContext = new GridContext({
        sortBy: 'name',
        sortAscending: true
    });

    addNewCustomField(): void {
        this.commonService.openModal(CreateEditEntityModalComponent,
            { modalData: new Object({ data: this.profile, handle: this.currentHandle }) });
    }

    responseCallback = (response: any) => {
        if (response && response.profile) {
            this.profile = new CustomFieldProfile(response.profile);
            response.customMetadataFields = response.profile.customMetadataFields;
        }
    }

    saveChanges(): Promise<boolean> { return Promise.resolve(true); }

    selectedTreeItemChanged(node: GenericTreeNode, projectHandle?: string, settingsType?: SettingsType): void {
        this.settingsType = settingsType;
        this.projectHandle = projectHandle;
        this.currentHandle = node.data instanceof Template ? node.data.handle : projectHandle;
        this.helpIndex = projectHandle ? HelpIndex.case_custom_fields_dlg : HelpIndex.org_custom_fields_template_dlg;
        const permissionType = projectHandle ? ObjectActionListType.PRJ_CUSTOM_FIELDS : ObjectActionListType.ORG_CUSTOM_FIELDS;
        this.hasPermissions = Permissions.checkUserPermissions([{ permissionType: permissionType, permissionActions: [ActionType.CREATE] }]);
        if (this.currentHandle) {
            this.requestInfo.data = {
                handle: this.currentHandle
            };
        }
        this.genericGrid.loadData();
    }

    ngOnDestroy(): void {
        if (this.settingsType === SettingsType.project) {
            this.metadataService.getCustomMetadataFields(this.settingsType, this.projectHandle, null);
        } else if (this.settingsType === SettingsType.organization) {
            this.metadataService.getCustomMetadataFields(this.settingsType, null, this.commonService?.currentUser?.customerName);
        }
    }
}